const translation = {
  daysInWeek: {
    Sat: 'شنبه',
    Sun: 'خورشید',
    Mon: 'مون',
    Wed: 'چهارشنبه',
    Fri: 'جمعه',
    Tue: 'سه شنبه',
    Thu: 'پنج‌شنبه',
  },
  months: {
    October: 'اکتبر',
    February: 'فوریه',
    September: 'سپتامبر',
    July: 'جولای',
    August: 'اوت',
    January: 'ژانویه',
    April: 'آوریل',
    November: 'نوامبر',
    March: 'مارس',
    May: 'مه',
    June: 'ژوئن',
    December: 'دسامبر',
  },
  operation: {
    pickDate: 'تاریخ را انتخاب کنید',
    ok: 'خوب',
    now: 'حالا',
    cancel: 'لغو',
  },
  title: {
    pickTime: 'زمان انتخاب کنید',
  },
  defaultPlaceholder: 'زمانی را انتخاب کنید...',
}

export default translation
